module.exports = __webpack_public_path__ + "static/media/ain_ghazal_text_01.d1507d64.jpg";